var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLabuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#781B85;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.8,536.7v-195h41.2v161h83.6v34H106.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.8,536.7h-44.2l67.3-195h53.1l67.2,195h-44.2l-48.9-150.5h-1.5L287.8,536.7z M285.1,460.1h104.4v32.2 H285.1V460.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M445.1,536.7v-195h78.1c14.3,0,26.3,2.1,35.9,6.4c9.6,4.3,16.8,10.1,21.6,17.7s7.2,16.2,7.2,26 c0,7.6-1.5,14.3-4.6,20c-3,5.7-7.2,10.4-12.5,14.1c-5.3,3.7-11.3,6.2-18.1,7.8v1.9c7.4,0.3,14.4,2.4,20.9,6.3 c6.5,3.9,11.8,9.3,15.9,16.2c4.1,7,6.1,15.2,6.1,24.8c0,10.3-2.6,19.6-7.7,27.7c-5.1,8.1-12.7,14.5-22.6,19.2 c-10,4.7-22.3,7-36.9,7H445.1z M486.3,423.3h30.6c5.7,0,10.7-1,15.1-3c4.4-2,7.9-4.8,10.5-8.5c2.6-3.7,3.9-8.1,3.9-13.2 c0-7-2.5-12.7-7.5-17c-5-4.3-12-6.5-21.2-6.5h-31.3V423.3z M486.3,503H520c11.5,0,19.9-2.2,25.1-6.6c5.3-4.4,7.9-10.3,7.9-17.7 c0-5.4-1.3-10.2-3.9-14.3c-2.6-4.1-6.3-7.4-11.1-9.7c-4.8-2.3-10.5-3.5-17.1-3.5h-34.6V503z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M733.2,341.7h41.2v126.7c0,14.2-3.4,26.7-10.1,37.3c-6.8,10.7-16.2,19-28.3,24.9c-12.1,5.9-26.3,8.9-42.4,8.9 c-16.2,0-30.3-3-42.5-8.9c-12.1-5.9-21.6-14.2-28.3-24.9c-6.7-10.7-10.1-23.1-10.1-37.3V341.7h41.2v123.1c0,7.4,1.6,14,4.9,19.8 c3.3,5.8,7.9,10.3,13.9,13.6c6,3.3,12.9,5,20.9,5c8,0,15-1.7,20.9-5c5.9-3.3,10.5-7.8,13.8-13.6c3.3-5.8,4.9-12.4,4.9-19.8V341.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabuIcon);
export default __webpack_public_path__ + "static/media/labu_icon.135bfbeb963805dd6a9c2789cb5c8d00.svg";
export { ForwardRef as ReactComponent };